const MAX_SUGGESTIONS = 10;

export default {
  MAX_SUGGESTIONS,
};
